import { useQuery } from "@tanstack/react-query";
import LoadBoardService from "../app/data/load-board/loadBoardService";
import { LoadboardListManifestRequestParams } from "../app/data/load-board/models";
import { QUERY_KEYS } from "app/data/common/queryKeys";
const loadBoardService = LoadBoardService.getInstance();

export const useLoadboardManifestTrips = (params: LoadboardListManifestRequestParams) => {
    return useQuery({
        // queryKey: [QUERY_KEYS.LOADBOARD_LIST, params],
        // queryFn: async () => {
        //     const response = await loadBoardService.getManifestTrips(params);
        //     return response.data;
        // },
        // enabled: !!params.startCutDate && !!params.endCutDate,
        queryKey: [QUERY_KEYS.LOADBOARD_LIST, params],
        queryFn: async () => {
            // Create a clean object containing only defined values
            const cleanParams = Object.entries(params).reduce((acc, [key, value]) => {
                if (value !== undefined && value !== null && value !== "") {
                    acc[key as keyof LoadboardListManifestRequestParams] = value;
                }
                return acc;
            }, {} as LoadboardListManifestRequestParams);

            const response = await loadBoardService.getManifestTrips(cleanParams);
            return response.data;
        },
        enabled: true,
    });
};